import { Create, SimpleForm } from "react-admin";
import { AnalysisGroupForm } from "./AnalysisGroupForm";

import { SaveAction } from "./utils/SaveAction";
import { formatGroupToSend } from "..";

export const AnalysisGroupCreate = () => (
  <Create redirect="list" transform={formatGroupToSend}>
    <SimpleForm mode="onBlur" reValidateMode="onBlur" toolbar={<SaveAction />}>
      <AnalysisGroupForm />
    </SimpleForm>
  </Create>
);
